export default function ResetPasswordPage() {
  return (
    <div className="bg-white rounded-xl p-8 shadow-lifted">
      <h1 className="font-display text-heading-lg text-center mb-2">Set new password</h1>
      <p className="text-center text-warm-gray mb-8">Create a new password for your account</p>
      <form className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-navy mb-1">New password</label>
          <input type="password" className="input" minLength={8} required />
        </div>
        <div>
          <label className="block text-sm font-medium text-navy mb-1">Confirm password</label>
          <input type="password" className="input" minLength={8} required />
        </div>
        <button type="submit" className="btn-primary w-full justify-center">
          Reset password
        </button>
      </form>
    </div>
  );
}
